import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import Select from '../../form/form-select'

import '../module.styl'
class ModulePub extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.types = ["Web", "Tablette", "Mobile"].map( t => ({id: t, value: t}) );
        this.pubPositions = [];
        ["Frame", "Top", "Bottom"].forEach( position => [1,2,3].forEach(num => this.pubPositions.push(position + num))  );
        this.pubPositions = this.pubPositions.map( t => ({id: t, value: t}) );

        this.devicesTemplate = this.devicesTemplate.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        console.log('ModulePub', nextProps);
        this.setState({disabled: nextProps.disabled})
    }

    devicesTemplate(device) {
        let { disabled } = this.state;
        return <div className="module-pub-devices">
            <Select disabled={disabled} value={device.type} options={this.types} />
            <Text disabled={disabled} value={device.width} />
            <Text disabled={disabled} value={device.height} />
        </div>
    }

    render() {
        let { devices=[], onChange, pubPosition } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-pub">
            <Select disabled={disabled} value={pubPosition} options={this.pubPositions} label={'app.modules.pub'} />

            <div clasdevicessName="module-pub-devices">
                <div className="select"> <FormattedMessage id={'app.type'} /></div>
                <div className="input"> <FormattedMessage id={'app.width'} /></div>
                <div className="input"> <FormattedMessage id={'app.height'} /></div>
            </div>
            {!disabled && <ListExpandable collection={devices} template={ this.devicesTemplate } />}
           <List printable={!disabled} collection={ devices.map(this.devicesTemplate) } />
        </div>;
    }
}

ModulePub.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    pubPosition: PropTypes.string, // souhld be .isRequired,.isRequired,
    devices: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            width: PropTypes.string.isRequired,
            height: PropTypes.string.isRequired
        })).isRequired
}

export default ModulePub;

